/**
 * Native Select Component
 * 
 * Simple HTML select wrapper that works with children options
 */

import React from 'react'
import { cn } from '../../utils/cn'

/**
 * Props interface for NativeSelect component
 */
interface NativeSelectProps {
  /** Current value */
  value: string
  /** Change handler that receives the new value */
  onValueChange: (value: string) => void
  /** Additional CSS classes */
  className?: string
  /** Whether the select is disabled */
  disabled?: boolean
  /** Children (option elements) */
  children: React.ReactNode
}

/**
 * NativeSelect Component
 * 
 * Works with native HTML option elements as children
 */
export const NativeSelect: React.FC<NativeSelectProps> = ({
  value,
  onValueChange,
  className,
  disabled = false,
  children
}) => {
  return (
    <select
      value={value}
      onChange={(e) => onValueChange(e.target.value)}
      disabled={disabled}
      className={cn(
        'w-full px-3 py-2 border rounded-lg shadow-sm',
        'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
        'text-gray-900 bg-white border-gray-300',
        'transition-colors duration-200',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      {children}
    </select>
  )
}

export default NativeSelect